import React from 'react';

const InputLabel = ({ input, rules = {} }) => {
  return (
    <label htmlFor={'' + input.id}>
      {input.campo} {rules.hasOwnProperty('required') && '*'}
    </label>
  );
};

export default InputLabel;
